import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Lightbulb = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path d="M7.25 1V2.5H8.75V1H7.25Z" fill="currentColor" />
    <path
      d="M8 4.75C6.19657 4.75 4.75 6.14449 4.75 8C4.75 9.28595 5.44628 10.2644 6.53157 10.8365L6.93182 11.0475V12.5H5.43182V11.9304C4.13972 11.1019 3.25 9.74512 3.25 8C3.25 5.29916 5.38515 3.25 8 3.25C10.6148 3.25 12.75 5.29916 12.75 8C12.75 9.74512 11.8603 11.1019 10.5682 11.9304V12.5H9.06818V11.0475L9.46843 10.8365C10.5537 10.2644 11.25 9.28595 11.25 8C11.25 6.14449 9.80343 4.75 8 4.75Z"
      fill="currentColor"
    />
    <path d="M10 13.5V15H6V13.5H10Z" fill="currentColor" />
    <path d="M2.5 8.75H1V7.25H2.5V8.75Z" fill="currentColor" />
    <path d="M13.5 8.75H15V7.25H13.5V8.75Z" fill="currentColor" />
    <path d="M3.03033 2.96967L4.03033 3.96967L2.96967 5.03033L1.96967 4.03033L3.03033 2.96967Z" fill="currentColor" />
    <path d="M13.0303 5.03033L14.0303 4.03033L12.9697 2.96967L11.9697 3.96967L13.0303 5.03033Z" fill="currentColor" />
  </Icon>
));

export default Lightbulb;
